module.exports = __webpack_public_path__ + "img/vector-1.c02164db.png";